import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { ITINERARY_CHANGE_ROUTE_PATH } from '../../../../config/paths';
import ItineraryChangeRouteForm from './ItineraryChangeRouteForm';
import { postItineraryChangeRoute } from '../../../../actions/itinerary/ItineraryChangeRoute';

const NewItineraryChangeRoute = ({
  breadcrumbs,
  dispatchPostItineraryChangeRoute,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      newRouteId: formValues.newRouteId ? formValues.newRouteId.value : null,
      newCircuitId: formValues.newCircuitId
        ? formValues.newCircuitId.value
        : null,
      serviceTypeId: formValues.serviceTypeId
        ? formValues.serviceTypeId.value
        : null,
    };

    dispatchPostItineraryChangeRoute(newFormValues);
  };

  const content = <ItineraryChangeRouteForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Cambio de Ruta"
      subtitle="Crear cambio de ruta en itinerario"
      content={content}
    />
  );
};

NewItineraryChangeRoute.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostItineraryChangeRoute: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostItineraryChangeRoute: postItineraryChangeRoute,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cambios de Ruta en Itinerarios',
      href: ITINERARY_CHANGE_ROUTE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewItineraryChangeRoute);
